import { Hidden } from '@material-ui/core';
import CatalogueApi from 'api/query/catalogue/catalogue-api';
import { CatalogueExtended } from 'api/query/catalogue/catalogue-extended';
import Axios, { CancelTokenSource } from 'axios';
import { DropdownItem } from 'components/dropdown/dropdown-item';
import React, { useCallback, useEffect, useState } from 'react';
import { PenCardsContainer } from '../pen-cards-container/pen-cards-container';
import { CreatePenCardForm } from './create-pen-card-form/create-pen-card-form';
import { CreatePenCardProps } from './create-pen-card-props';
import { initialASBVsColumns } from './create-pen-card-utils';
import './create-pen-card.scss';
import { getObjectives } from '../../../search/prime/prime-utils';

export const CreatePenCard: React.FC<CreatePenCardProps> = (props) => {
  const {
    id,
    db,
    trait,
    user,
  } = props;

  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [catalogue, setCatalogue] = useState<CatalogueExtended>();
  const [traits, setTraits] = useState<number>();

  // combined selected index and asbvs, posted to create pen card
  const [selectedItems, setSelectedItems] = useState<DropdownItem[]>(initialASBVsColumns);
  const [imgSrc, setImgSrc] = useState<string>();

  /**
   * Calls catalogue api to get more information about selected catalogue.
   */
  const loadCatalogue = useCallback(async (source: CancelTokenSource) => CatalogueApi.getById(id, db, source.token), [db, id]);

  const generatePdf = () => {
    setLoading(false);
    // redirect to my catalogues
    const linkToMyCatalogues = document.getElementsByClassName('back-to__link')[0] as HTMLDivElement;
    setTimeout(() => {
      linkToMyCatalogues.click();
    }, 1000);
  };

  const cardReady = (isReady: boolean) => {
    if (isReady && loading) {
      generatePdf();
    }
  };

  const cardFailed = () => {
    setLoading(false);
    setError(true);
  };

  const saveItems = (asbvs: DropdownItem[], image: string | undefined) => {
    setLoading(true);
    setSelectedItems(asbvs);
    setImgSrc(image);
  };

  /*
     * Initial catalogue retrieve.
     */
  useEffect(() => {
    const source = Axios.CancelToken.source();

    setTraits(trait || getObjectives(db)[(db === 2 || db === 5) ? 1 : 0]?.id);
    const getCatalogues = async () => {
      const d = await loadCatalogue(source);
      setCatalogue(d);
    };
    getCatalogues();

    return () => {
      source.cancel();
    };
  }, [loadCatalogue]);

  return (
    <Hidden xsDown>
      <CreatePenCardForm
        id={id}
        db={db}
        trait={traits}
        catalogue={catalogue}
        load={loading}
        error={error}
        elements={(items, img) => saveItems(items, img)}
      />
      {(catalogue && !!selectedItems[0].id) && (
        <div className="sg-create-pen-card__cards">
          <PenCardsContainer
            catalogue={catalogue}
            db={db}
            user={user}
            traits={traits}
            penCardImg={imgSrc}
            asbvs={selectedItems}
            cardLoaded={(l: boolean) => cardReady(l)}
            cardFailed={cardFailed}
          />
        </div>
      )}
    </Hidden>
  );
};

(CreatePenCard as any).whyDidYouRender = true;
